import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text text--h7 text--negative"
}

import TimesSvg from '../assets/times.svg';
import ArrowLeftSvg from '../assets/arrow-left.svg';

// Components
import VPanelRow from './VPanelRow.vue';
import VInfoList from './VInfoList.vue';
import VInfoItem from './VInfoItem.vue';
import VTextarea from './VTextarea.vue';
import VInput from './VInput.vue';
import VSelect from './VSelect.vue';
import VButton from './VButton.vue';
import VUserSelectorNew from './VUserSelectorNew.vue';

// Other
import INumericCounter from '@/core/Models/INumericCounter';
import { PropType, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
    useNumericCounterTagNameSelector,
    useNumericCounterTagValueSelector,
    useNumericCounterUnitSelector,
} from '@/mixins/SelectorsApi';
import IQueryNumericCounterOptionsRequest from '@/core/Requests/IQueryNumericCounterUnitsRequest';
import { useNumericCounterForm } from '@/mixins/NumericCounterApi';
import { clone } from 'jsondiffpatch';


export default /*@__PURE__*/_defineComponent({
  __name: 'VNumericCounterControl',
  props: {
    units: { type: String, default: '' },
    tagName: { type: String as PropType<string | null>, default: null },
    tagValue: { type: String as PropType<string | null>, default: null },
    counter: { type: Object as PropType<INumericCounter>, required: true },
},
  emits: ['submit', 'close'],
  setup(__props, { emit: __emit }) {

// Svg
const { t } = useI18n();
const emit = __emit;
const props = __props;

let counter = ref(clone(props.counter) as INumericCounter);
let tagName = ref(props.tagName);
let tagValue = ref(props.tagValue);

const { createAsync, patchAsync } = useNumericCounterForm(counter);

let isValid = computed(() => !counter.value.units);
let isCreated = computed(() => counter.value.id !== -1);

let tagValueQuery = computed<IQueryNumericCounterOptionsRequest>(() =>
    tagName.value
        ? {
              whereTagName: [tagName.value],
          }
        : {},
);

const unitSelector = useNumericCounterUnitSelector();
const tagNameSelector = useNumericCounterTagNameSelector(null, [
    'kpi-numerics.system.user',
    'kpi-numerics.system.department',
]);
const tagValuesSelector = useNumericCounterTagValueSelector(tagValueQuery);

async function submit() {
    if (!isCreated.value) {
        const result = await createAsync();
        if (!result) {
            return;
        }
        counter.value = result;
    }

    if (counter.value.key !== props.counter.key || counter.value.name !== props.counter.name) {
        await patchAsync();
    }

    emit('submit', {
        counterId: counter.value.id,
        numericTagName: tagName.value,
        numericTagValue: tagValue.value,
    });
    emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VPanelRow, null, {
      default: _withCtx(() => [
        _createVNode(VTextarea, {
          modelValue: _unref(counter).name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(counter).name) = $event)),
          class: "simple-textarea--h2",
          "concurrency-mode": "",
          "debounce-mode": "",
          maxlength: "255",
          required: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(VPanelRow, {
      padding: "",
      separate: ""
    }, {
      default: _withCtx(() => [
        _createVNode(VInfoList, { class: "numeric-panel__info-list" }, {
          default: _withCtx(() => [
            _createVNode(VInfoItem, {
              center: "",
              description: _unref(t)('numeric-counter.key-description'),
              label: _unref(t)('numeric-counter.key')
            }, {
              default: _withCtx(() => [
                _createVNode(VInput, {
                  modelValue: _unref(counter).key,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(counter).key) = $event)),
                  class: "input-field--primary",
                  maxlength: "64",
                  placeholder: _unref(t)('default-placeholder', 0)
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["description", "label"]),
            _createVNode(VInfoItem, {
              center: "",
              label: _unref(t)('numeric-counter.units'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(VSelect, {
                  modelValue: _unref(counter).units,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(counter).units) = $event)),
                  class: "v-select--primary",
                  disabled: _unref(isCreated),
                  options: _unref(unitSelector).options.value,
                  placeholder: _unref(t)('default-placeholder', 10),
                  taggable: "",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(counter).units = $event.target.value)),
                  onOpen: _unref(unitSelector).prefetch
                }, null, 8, ["modelValue", "disabled", "options", "placeholder", "onOpen"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(VInfoItem, {
              center: "",
              description: _unref(t)('numeric.tag-name-description'),
              label: _unref(t)('numeric.tag-name')
            }, {
              default: _withCtx(() => [
                _createVNode(VSelect, {
                  class: "v-select--primary",
                  "model-value": _unref(tagName) && _unref(tagNameSelector).map ? _unref(tagNameSelector).map(_unref(tagName)) : _unref(tagName),
                  options: _unref(tagNameSelector).options.value,
                  placeholder: _unref(t)('default-placeholder', 0),
                  reduce: _unref(tagNameSelector).reduce,
                  taggable: "",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_isRef(tagName) //@ts-ignore
 ? tagName.value = $event.target.value : tagName = $event.target.value)),
                  onOpen: _unref(tagNameSelector).prefetch,
                  "onOption:selected": _cache[5] || (_cache[5] = 
                        (event) => {
                            _isRef(tagName) //@ts-ignore
 ? tagName.value = event.value ?? event.label : tagName = event.value ?? event.label;
                            _isRef(tagValue) //@ts-ignore
 ? tagValue.value = null : tagValue = null;
                        }
                    )
                }, null, 8, ["model-value", "options", "placeholder", "reduce", "onOpen"])
              ]),
              _: 1
            }, 8, ["description", "label"]),
            _createVNode(VInfoItem, {
              center: "",
              description: _unref(t)('numeric.tag-value-description'),
              label: _unref(t)('numeric.tag-value')
            }, {
              default: _withCtx(() => [
                (_unref(tagName) === 'kpi-numerics.system.user')
                  ? (_openBlock(), _createBlock(VUserSelectorNew, {
                      key: 0,
                      class: "v-select--primary v-select--invisible v-select--no-option-padding v-select--form-user-selector",
                      "model-value": _unref(tagValue) ? [_unref(tagValue)] : [],
                      onSelected: _cache[6] || (_cache[6] = ($event: any) => (_isRef(tagValue) //@ts-ignore
 ? tagValue.value = $event : tagValue = $event))
                    }, null, 8, ["model-value"]))
                  : (_openBlock(), _createBlock(VSelect, {
                      key: 1,
                      modelValue: _unref(tagValue),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(tagValue) ? (tagValue).value = $event : tagValue = $event)),
                      class: "v-select--primary",
                      options: _unref(tagValuesSelector).options.value,
                      placeholder: _unref(t)('default-placeholder', 0),
                      taggable: "",
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (_isRef(tagValue) //@ts-ignore
 ? tagValue.value = $event.target.value : tagValue = $event.target.value)),
                      onOpen: _unref(tagValuesSelector).prefetch
                    }, null, 8, ["modelValue", "options", "placeholder", "onOpen"]))
              ]),
              _: 1
            }, 8, ["description", "label"]),
            (_unref(counter).units && __props.units && _unref(counter).units.toLowerCase() !== __props.units.toLowerCase())
              ? (_openBlock(), _createElementBlock("small", _hoisted_1, _toDisplayString(_unref(t)('numeric-counter.units-not-match-description')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(VPanelRow, {
      down: "",
      end: "",
      gap: "",
      padding: "",
      "separate-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(VButton, {
          class: "button--primary button--negative button--vcenter",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cancel')) + " ", 1),
            _createVNode(_unref(TimesSvg))
          ]),
          _: 1
        }),
        _createVNode(VButton, {
          class: "button--primary button--green button--vcenter",
          disabled: _unref(isValid),
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('apply')) + " ", 1),
            _createVNode(_unref(ArrowLeftSvg), { class: "rotate-180" })
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ], 64))
}
}

})